module.exports = __webpack_public_path__ + "img/style_11_pl.98976c1f.jpeg";